/* eslint-disable no-redeclare */
import { z } from 'zod';

export const Subsidy = z.number().positive();
export type Subsidy = z.infer<typeof Subsidy>;
